import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeEvery } from 'redux-saga/effects';

import { fromDto as reservationFromDto } from '../../../models/adapters/ReservationAdapter';
import { waitBeforeFetch } from '../../../utils/FetchState';
import {
  fetchReservations,
  FetchReservationsPayload,
  reservationsFetched,
  reservationsFetchFailed,
  ReservationsFetchResponsePayload,
} from '../../actions/reservation/fetchReservations';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function createFetchReservationsResponseAction(placeUuid: string, response): Action<ReservationsFetchResponsePayload> {
  const { error, reservations } = response;
  const timestamp = moment();
  if (!error) {
    return reservationsFetched({
      placeUuid,
      reservations: reservations.map((reservation) => reservationFromDto(reservation)),
      timestamp,
    });
  }
  return reservationsFetchFailed({ placeUuid, timestamp });
}

function* fetchReservationsSaga({ payload }: Action<FetchReservationsPayload>) {
  const token = yield getAuthenticationToken();
  const { placeUuid, fetchState } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getReservations, token, { placeUuid });
  const action = createFetchReservationsResponseAction(placeUuid, response);
  yield put(action);
}

export default function* watchFetchReservationsSaga() {
  yield takeEvery(fetchReservations, fetchReservationsSaga);
}
